import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import classNames from "classnames";
import ChromeIcon from "./assets/chrome.svg";
import SafariIcon from "./assets/safari.svg";
import EdgeIcon from "./assets/edge.svg";
import BrowserLink from "./components/BrowserLink";
import { useStyles } from "./BrowserLinksStyles";

interface Props {
  className?: string;
}

export const BrowserLinks = (props: Props): JSX.Element => {
  const { className } = props;
  const { t } = useI18n(["common", "compatibility"]);
  const styles = useStyles();

  return (
    <div className={classNames(styles.linksContainer, className)}>
      <Typography component="div" className={styles.desktopTitle}>
        {t("compatibility:browser.data")}
      </Typography>
      <div className={styles.desktopLinks}>
        <BrowserLink
          url="https://support.apple.com/en-us/HT204416"
          title={t("compatibility:title.mac")}
          image={SafariIcon}
        />
        <BrowserLink
          url="https://www.google.com/chrome/"
          title={t("compatibility:title.chrome")}
          image={ChromeIcon}
        />
        <BrowserLink
          url="https://www.microsoft.com/edge"
          title={t("compatibility:edge.title")}
          image={EdgeIcon}
        />
      </div>
      <Typography component="div" className={styles.mobileTitle}>
        {t("compatibility:mobile.browsers")}
      </Typography>
      <div className={styles.mobileLinks}>
        <BrowserLink
          url=""
          title={t("compatibility:title.safari")}
          image={SafariIcon}
        />
        <BrowserLink
          url="https://play.google.com/store/apps/details?id=com.android.chrome"
          title={t("compatibility:title.android.chrome")}
          image={ChromeIcon}
        />
      </div>
    </div>
  );
};
